import React from 'react';
import styled from '@benzinga/themetron';
import { formatPriceWithCurrency } from '@benzinga/utils';
import { QuoteChange, QuoteChangePercent } from '@benzinga/quotes-ui';
import { Future } from '@benzinga/commodities-manager';
import { Button } from '@benzinga/core-ui';

interface FuturesTableProps {
  futures?: Future[];
  link?: string;
}

export const FuturesTable: React.FC<FuturesTableProps> = ({ futures, link }) => {
  return (
    <FuturesTableWrapper>
      <table>
        <thead>
          <tr>
            <th>Symbol</th>
            <th>Name</th>
            {/* <th>Category</th> */}
            <th>Change</th>
            <th>Change %</th>
            <th>Close Price</th>
            <th>Close Date</th>
            {link && <th>Buy Now</th>}
          </tr>
        </thead>
        <tbody>
          {futures?.map(future => {
            const change = future.close - future.open;
            const percentageChange = (change / future.close) * 100;
            return (
              <tr key={future.symbol}>
                <td className="symbol">
                  <a href={`/futures/${future.symbol}`}>{future.symbol}</a>
                </td>
                <td className="name">
                  <a href={`/futures/${future.symbol}`}>{future?.name}</a>
                </td>
                {/* <td>{future.category}</td> */}
                <td className="change">
                  <QuoteChange absoluteChange={change} />
                </td>
                <td className="change-percent">
                  <QuoteChangePercent percentageChange={percentageChange} />
                </td>
                <td className="close">{formatPriceWithCurrency(future.close, future.currency)}</td>
                <td className="date">{future.date}</td>
                {link && (
                  <td className="buy-now">
                    <Button aria-label="Buy Now" as="a" className="buy-now" href={link} size="sm" variant="primary">
                      Buy Now
                    </Button>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </FuturesTableWrapper>
  );
};

const FuturesTableWrapper = styled.div`
  display: block;
  overflow-x: auto;
  white-space: nowrap;
  table {
    width: 100%;
    text-align: left;
  }
  thead {
    tr {
      border-bottom: solid 1px #ccc;
    }
  }
  td,
  th {
    padding: 0.25rem 0.5rem;
    white-space: nowrap;
  }
  tr {
    border-bottom: solid 1px #ddd;
  }
  td {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 1;
    &.symbol {
      width: 80px;
      max-width: 80px;
    }
    &.name {
      width: 180px;
      max-width: 180px;
    }
    &.close {
      font-weight: bold;
    }
    &.change-percent {
      white-space: wrap;
    }
    &.close,
    &.date,
    &.change,
    &.change-percent,
    &.buy-now {
      width: 120px;
      max-width: 120px;
      a {
        margin-bottom: 0;
      }
    }
  }
`;
